<template>
  <div>
    <section class="content-header">
      <h1>Members Profile</h1>
    </section>

    <section class="content">
      <div class="row">
        <!-- Left column -->
        <div class="col-xl-4 col-lg-5">
          <swap-leg></swap-leg>

          <div class="cyber-profile-card">
            <div class="cyber-profile-card__glow"></div>
            <div class="cyber-profile-card__body">
              <div class="cyber-profile-card__avatar-wrap">
                <img
                  class="cyber-profile-card__avatar"
                  :src="$store.getters.currentUser.avatar"
                  alt="User profile picture"
                />
                <div class="cyber-profile-card__avatar-ring"></div>
              </div>

              <form>
                <input
                  @change="changePicture"
                  type="file"
                  ref="picture"
                  required
                  class="d-none"
                  accept="image/x-png,image/gif,image/jpeg"
                />
                <button
                  @click="$refs.picture.click()"
                  type="button"
                  class="btn btn-primary btn-sm cyber-profile-card__upload"
                  :disabled="loading"
                >
                  <template v-if="!loading">
                    <i class="fa fa-camera mr-1"></i> Change Photo
                  </template>
                  <template v-else>
                    Loading <i class="fa fa-spinner fa-spin"></i>
                  </template>
                </button>
              </form>

              <h3 class="cyber-profile-card__name">
                {{ this.$store.getters.currentUser.username }}
              </h3>
              <p class="cyber-profile-card__email">
                <i class="mdi mdi-email-outline mr-1"></i>
                {{ $store.getters.currentUser.email }}
              </p>

              <div class="cyber-profile-card__links">
                <router-link :to="{ name: 'Network' }" class="cyber-profile-card__link">
                  <i class="mdi mdi-source-branch"></i>
                  <span>My Network</span>
                  <i class="mdi mdi-chevron-right"></i>
                </router-link>
                <router-link :to="{ name: 'Reports' }" class="cyber-profile-card__link">
                  <i class="mdi mdi-chart-timeline-variant"></i>
                  <span>Reports</span>
                  <i class="mdi mdi-chevron-right"></i>
                </router-link>
                <router-link :to="{ name: 'Balance' }" class="cyber-profile-card__link">
                  <i class="mdi mdi-wallet-outline"></i>
                  <span>My Balance</span>
                  <i class="mdi mdi-chevron-right"></i>
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <!-- Right column -->
        <div class="col-xl-8 col-lg-7">
          <form @submit.prevent="updateUser">
            <!-- Personal Details -->
            <div class="cyber-form-card">
              <div class="cyber-form-card__glow"></div>
              <div class="cyber-form-card__header">
                <i class="mdi mdi-account-outline"></i>
                <h4>Personal Details</h4>
              </div>
              <div class="cyber-form-card__body">
                <div class="form-group row">
                  <label class="col-sm-2 col-form-label">Sponsor</label>
                  <div class="col-sm-10">
                    <template v-if="model.sponsor">
                      <input class="form-control" type="text" v-model="model.sponsor.username" disabled />
                    </template>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-2 col-form-label">Full Name</label>
                  <div class="col-sm-10">
                    <input class="form-control" type="text" placeholder="Name and last name" v-model="model.name" />
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-2 col-form-label">Email</label>
                  <div class="col-sm-10">
                    <input class="form-control" type="email" placeholder="example@example.com" v-model="model.email" readonly />
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-2 col-form-label">Phone</label>
                  <div class="col-sm-10">
                    <input class="form-control" type="tel" placeholder="123 456 7890" v-model="model.phone" />
                  </div>
                </div>
              </div>
            </div>

            <!-- USDT Wallet -->
            <div class="cyber-form-card">
              <div class="cyber-form-card__glow cyber-form-card__glow--cyan"></div>
              <div class="cyber-form-card__body">
                <div class="form-group row mb-0">
                  <label class="col-sm-2 col-form-label">USDT Wallet (TRC20)</label>
                  <div class="col-sm-10 input-group">
                    <span class="input-group-addon">
                      <cryptoicon symbol="usdt" size="25" />
                    </span>
                    <input v-model="model.token_wallet" class="form-control" type="text" placeholder="Your USDT (TRC20) Wallet" />
                  </div>
                </div>
              </div>
            </div>

            <!-- Address -->
            <div class="cyber-form-card">
              <div class="cyber-form-card__glow"></div>
              <div class="cyber-form-card__body">
                <div class="form-group row">
                  <label class="col-sm-2 col-form-label">Address</label>
                  <div class="col-sm-10">
                    <input class="form-control" type="text" placeholder="A-458, Lorem Ipsum, city" v-model="model.address" />
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-2 col-form-label">City</label>
                  <div class="col-sm-10">
                    <input class="form-control" type="text" placeholder="Your City" v-model="model.city" />
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-2 col-form-label">Country</label>
                  <div class="col-sm-10">
                    <input class="form-control" type="text" placeholder="Canada" v-model="model.country" />
                  </div>
                </div>
              </div>
            </div>

            <!-- Security -->
            <div class="cyber-form-card">
              <div class="cyber-form-card__glow cyber-form-card__glow--magenta"></div>
              <div class="cyber-form-card__header">
                <i class="mdi mdi-shield"></i>
                <h4>Security</h4>
              </div>
              <div class="cyber-form-card__body">
                <email-auth-code @code-changed="(evt) => (model.email_auth_code = evt)" />

                <div class="form-group row">
                  <label class="col-sm-2 col-form-label">New Password</label>
                  <div class="col-sm-10">
                    <input class="form-control" type="text" v-model="model.password" />
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-2 col-form-label">Confirm Password</label>
                  <div class="col-sm-10">
                    <input class="form-control" type="text" v-model="model.password_confirmation" />
                  </div>
                </div>
                <div class="form-group row">
                  <div class="ml-auto col-sm-10">
                    <button :disabled="loading" type="submit" class="btn btn-success btn-block">
                      <template v-if="loading">
                        <i class="fa fa-spinner fa-spin"></i> Loading
                      </template>
                      <template v-else>
                        Save Changes <i class="mdi mdi-content-save ml-1"></i>
                      </template>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
/* Profile card */
.cyber-profile-card {
  background: linear-gradient(135deg, #252525, #2e2e2e);
  border: 1px solid #3d3d37;
  border-radius: 14px;
  overflow: hidden;
  margin-bottom: 20px;
  position: relative;
}

.cyber-profile-card__glow {
  height: 2px;
  background: linear-gradient(90deg, transparent, #B09A4E, transparent);
}

.cyber-profile-card__body {
  padding: 25px 20px;
  text-align: center;
}

.cyber-profile-card__avatar-wrap {
  position: relative;
  display: inline-block;
  margin-bottom: 15px;
}

.cyber-profile-card__avatar {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 3px solid rgba(176, 154, 78, 0.3);
  box-shadow: 0 0 20px rgba(176, 154, 78, 0.15);
  object-fit: cover;
}

.cyber-profile-card__avatar-ring {
  position: absolute;
  top: -4px; left: -4px;
  right: -4px; bottom: -4px;
  border: 1px solid rgba(176, 154, 78, 0.15);
  border-radius: 50%;
  animation: ringPulse 3s ease-in-out infinite;
}

@keyframes ringPulse {
  0%, 100% { opacity: 0.3; transform: scale(1); }
  50% { opacity: 0.7; transform: scale(1.03); }
}

.cyber-profile-card__upload {
  font-size: 0.7rem !important;
  padding: 6px 14px !important;
  margin-bottom: 15px;
}

.cyber-profile-card__name {
  font-family: 'Orbitron', sans-serif !important;
  font-size: 1rem !important;
  color: #B09A4E !important;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 5px !important;
  text-shadow: 0 0 10px rgba(176, 154, 78, 0.2);
}

.cyber-profile-card__email {
  color: #9A998F;
  font-size: 0.85rem;
  margin-bottom: 20px;
}

.cyber-profile-card__links {
  border-top: 1px solid #3d3d37;
  padding-top: 15px;
}

.cyber-profile-card__link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  color: #C2C1B8 !important;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.2s ease;
  cursor: pointer;
}

.cyber-profile-card__link:hover {
  background: rgba(176, 154, 78, 0.05);
  color: #B09A4E !important;
}

.cyber-profile-card__link i:first-child {
  color: #9A998F;
  font-size: 1.1rem;
}

.cyber-profile-card__link:hover i:first-child {
  color: #B09A4E;
}

.cyber-profile-card__link span {
  flex: 1;
  text-align: left;
}

.cyber-profile-card__link i:last-child {
  color: #6B6A62;
  font-size: 1rem;
}

/* Form card */
.cyber-form-card {
  background: #252525;
  border: 1px solid #3d3d37;
  border-radius: 14px;
  overflow: hidden;
  margin-bottom: 20px;
  position: relative;
}

.cyber-form-card__glow {
  height: 2px;
  background: linear-gradient(90deg, transparent, #B09A4E, transparent);
}

.cyber-form-card__glow--cyan {
  background: linear-gradient(90deg, transparent, #7BBFB5, transparent);
}

.cyber-form-card__glow--magenta {
  background: linear-gradient(90deg, transparent, #C46B8F, transparent);
}

.cyber-form-card__header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 18px 20px;
  border-bottom: 1px solid #3d3d37;
}

.cyber-form-card__header i {
  color: #B09A4E;
  font-size: 1.2rem;
}

.cyber-form-card__header h4 {
  font-family: 'Orbitron', sans-serif !important;
  font-size: 0.8rem !important;
  color: #E0DFD8 !important;
  margin: 0 !important;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.cyber-form-card__body {
  padding: 20px;
}
</style>

<script>
import { EmailAuthCode } from "@/components";
import SwapLeg from "@/components/SwapLeg";

export default {
  name: "user-profile",
  data() {
    return {
      loading: false,
      model: {
        username: "",
        email: "",
        name: "",
        last_name: "",
        address: "",
        city: "",
        country: "",
        zip: "",
        about: "",
        link: "",
        btc_wallet: "",
      },
    };
  },
  components: { EmailAuthCode, SwapLeg },
  created() {
    this.model = this.$store.getters.currentUser;
  },
  methods: {
    changePicture(env) {
      env.preventDefault();
      this.loading = true;
      let data = new FormData();
      data.append("file", this.$refs.picture.files[0]);

      this.$http({
        method: "put",
        url: "/api/v1/client/users/" + this.$store.getters.currentUser.uuid,
        data: data,
        headers: {
          "content-type": "application/json",
          Authorization: this.$store.getters.authToken,
        },
      })
        .then(() => {
          this.$store.dispatch("getUser");
          this.$toasted.show("Profile picture updated!", {
            position: "top-right",
            duration: 5000,
            type: "success",
            closeOnSwipe: true,
          });
          this.loading = false;
        })
        .catch((error) => {
          error.response.data &&
            error.response.data.map((m) => {
              this.$toasted.show(m, {
                position: "top-right",
                duration: 5000,
                type: "error",
                closeOnSwipe: true,
              });
            });
          this.loading = false;
        });
    },
    onCopy() {
      this.$toasted.show("Copied to clipboard!", {
        position: "top-right",
        duration: 5000,
        type: "success",
        closeOnSwipe: true,
      });
    },
    swapLeg(leg) {
      leg = leg === "left" ? false : true;
      this.loading = true;
      this.updateUser({ right: leg });
    },
    updateUser() {
      this.loading = true;
      this.$http({
        method: "put",
        url: "/api/v1/client/users/" + this.$store.getters.currentUser.uuid,
        data: this.model,
        headers: {
          "content-type": "application/json",
          Authorization: this.$store.getters.authToken,
        },
      })
        .then(() => {
          this.$store.dispatch("getUser");
          this.$toasted.show("Profile Updated!", {
            position: "top-right",
            duration: 5000,
            type: "success",
            closeOnSwipe: true,
          });
          this.loading = false;
        })
        .catch((error) => {
          error.response.data &&
            error.response.data.map((m) => {
              this.$toasted.show(m, {
                position: "top-right",
                duration: 5000,
                type: "error",
                closeOnSwipe: true,
              });
            });
          this.loading = false;
        });
    },
  },
};
</script>
